import {
    AppBar, Card, CardContent, Toolbar, Typography
} from '@mui/material';

const DEFAULT_SHADOW = 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px';

const DashboardCard = ({
    title,
    action,
    children,
    className,
    cardSx,
    contentSx
}) => (
    <Card
        className={className}
        sx={{
            width: '100%',
            boxShadow: DEFAULT_SHADOW,
            ...cardSx
        }}
    >
        <AppBar position="static" sx={{ bgcolor: '#fff' }} elevation={0}>
            <Toolbar sx={{ gap: 1, flexWrap: 'wrap', py: 0.75 }}>
                <Typography
                    variant="body1"
                    sx={{ flexGrow: 1, color: '#000', fontWeight: 600 }}
                >
                    {title}
                </Typography>
                {action}
            </Toolbar>
        </AppBar>
        <CardContent sx={contentSx}>
            {children}
        </CardContent>
    </Card>
);

export default DashboardCard;
